import axios from '_u/axios'

// 品牌列表
export const brandList = (body) => {
    return axios.post('api/brand/info/list', body)
}

// 品牌详情
export const brandView = (id) => {
    return axios.post('api/brand/info/view', {
        id
    })
}

// 品牌新增
export const brandAdd = (body) => {
    return axios.post('api/brand/info/add', body)
}

// 品牌修改
export const brandUpdate = (body) => {
    return axios.post('api/brand/info/update', body)
}

// 品牌删除
export const brandDelete = (id) => {
    return axios.post('api/brand/info/delete', {
        id
    })
}